import React, {Component} from 'react';
import {connect} from 'react-redux'
import {Card, CardContent, Typography} from '@material-ui/core';
import ChatMedia from 'components/ChatMedia';
import Avatar from 'components/Avatar';
import moment from 'moment-timezone';

class ChatMessage extends Component {

    formatTimestamp = (timestamp) => {
        if (!timestamp) return '';
        // Parse timestamp as Europe/Madrid timezone and convert to local
        return moment.tz(timestamp, 'Europe/Madrid').local().format('HH:mm');
    }

    renderMessagePart = (msg) => {
        switch (msg.type) {
            case 'chat.file':
                return (
                    <Card elevation={0} className={`chat-media ${this.props.data.config.customization.messages_rubberband ? 'rubberBand' : ''}`}>
                        <CardContent>
                            <ChatMedia message={msg}/>
                        </CardContent>
                    </Card>
                )
            default:
                return (
                    <Card elevation={0} className={`chat-msg ${this.props.data.config.customization.messages_rubberband ? 'rubberBand' : ''}`}>
                        <CardContent>
                            <Typography color="textSecondary"
                                        dangerouslySetInnerHTML={{__html: this.props.message.msg}}>
                            </Typography>
                        </CardContent>
                    </Card>
                );
        }
    }

    render() {
        const {config} = this.props.data;
        const {message} = this.props;
        const timeString = this.formatTimestamp(message.timestamp);
        
        const showAvatar = message.nick === 'agent' 
            ? config.customization?.messages_agent_icon_show !== false
            : config.customization?.messages_user_icon_show !== false;
        
        return (
            <div className={`chat-msg-container ${message.nick} ${this.props.addClass}`}>
                {showAvatar && <Avatar config={config} nick={message.nick}/>}
                <div className="message-content-wrapper">
                    {this.renderMessagePart(message)}
                    {timeString && (
                        <span className="message-timestamp">{timeString}</span>
                    )}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        data: state
    }
}

const connect_message = connect(
    mapStateToProps
)(ChatMessage);

export default connect_message;

